import { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

type Margin = 'none' | 'dense' | 'normal';

@Component
export default class ClFormControlLabel extends Vue {
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  @Prop({
    type: String,
    default: 'div'
  })
  public component!: string;

  /**
   * If true, the label, input and helper text should be displayed in a disabled state.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public disabled!: boolean;

  /**
   * If true, the label should be displayed in an error state.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public error!: boolean;

  /**
   * If true, the component will take up the full width of its container.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public fullWidth!: boolean;

  /**
   * If dense or normal, will adjust vertical spacing of this and contained components.
   */
  @Prop({
    default: 'none',
    type: String as () => Margin,
    validator: x => ['none', 'dense', 'normal'].includes(x)
  })
  public margin!: Margin;

  /**
   * If true, the label will indicate that the input is required.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public required!: boolean;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-form-control': true,
        [`cl-form-control--margin--${this.margin}`]: this.margin !== 'none',
        [`cl-form-control--full-width`]: this.fullWidth
      }
    };
    return h(this.component, data, this.$slots.default);
  }
}
